// The humidity reading is an unsigned 12-bit integer value. The integer value is converted to humidity in percent (%) using the ConversionFormulaScale and ConversionFormulaOffset parameters. Convert the 12-bit integer value ($rdg in code below) to percent ($hum in code below) using the following algorithm:
// $hum = 0.0;

/*
if ( $rdg == 0xFFF ) {
  $hum = null; // display reading as “invalid”
} else {
  $kfactor = (float)$ConversionFormulaScale;
  $offset = (float)$ConversionFormulaOffset;
  $val = ($rdg * $kfactor) + $offset;

  if ( ($val >= 0.0) && ($val <= 100.0) ) {
    $hum = $val;
  }
}
*/

export function humidity(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const kfactor = scale
  const humidity = reading * kfactor + offset

  if (humidity >= 0.0 && humidity <= 100.0) {
    return humidity
  }

  return 0
}
